export default {
  general: 'Genel',
  vehicleDuties: 'Taşıt Görevleri',
  vehicleDutyInfo: 'Taşıt Görev Bilgileri',
  vehicleDutyDate: 'Görev Zamanı',
  details: 'Detaylar',
  fetching: 'Veri yükleniyor',
  nodata: 'Veri bulunamadı...',
  transferList: 'Transfer Listesi',
  createVehicleDuty: 'Taşıt Görevi Oluştur',
  transferRequest: 'Transfer İsteği',
  transferDetails: 'Transfer Detayları',
  createServiceRecord: 'Servis Talebi Oluştur',
  save: 'Kaydet',
  total: 'Toplam',
  approve: 'Onayla',
  aldim: 'Yolcuyu Aldım',
  biraktim: 'Yolcuyu Bıraktım',
  approved: 'Onaylandı',
  canceled: 'İptal Edildi',
  cancel: 'İptal',
  updated: 'Başarıyla Güncellendi',
  created: 'Başarıyla Oluşturuldu',
  reject: 'Reddet',
  cancelRequest: 'Talebi İptal Et',
  yes: 'Evet',
  no: 'Hayır',
  users: 'Kullanıcılar',
  board: 'Pano',
  createUser: 'Kullanıcı Oluştur',
  editUser: 'Kullanıcı Düzenle',
  edit: 'Düzenle',
  delete: 'Sil',
  loginFailed: 'Giriş Başarısız',
  username: 'Kullanıcı adı',
  password: 'Parola',
  passwordConfirmation: 'Parola tekrar',
  error: 'İşlem sırasında hata oluştu.',
  errorApproved: 'İstek daha önce iptal edildiğinden onaylanmadı.',
  create: 'Oluştur',
  close: 'Kapat',
  txtstatus: 'Durum',
  search: 'Ara',
  idSearch: 'ID Ara',
  nameSearch: 'İsim Arama',
  usernameSearch: 'Kullanıcı Adı',
  emailSearch: 'Eposta Ara',
  email: 'E-posta',
  emailAddress: 'E-posta Adresi',
  allRoles: 'Tüm Roller',
  department: 'Departman',
  departments: 'Departmanlar',
  departmentInfo: 'Departman Bilgileri',
  departmentName: 'Departman Adı',
  createDepartment: 'Departman Oluştur',
  departmentCreated: 'Departman oluşturuldu.',
  selectDepartment: 'Departman Seçiniz',
  area: 'Bölge',
  areas: 'Bölgeler',
  areaPermission: 'Bölge Yetkisi',
  selectArea: 'Bölge Seçiniz',
  phoneSearch: 'Telefon Ara',
  dateSearch: 'Tarih Aralığı Seç',
  date: 'Tarih',
  departureSearch: 'Kalkış Arama',
  departure: 'Kalkış',
  targetSearch: 'Hedef Arama',
  driverSearch: 'Sürücü Arama',
  plateSearch: 'Plaka Arama',
  brandSearch: 'Marka Arama',
  modelSearch: 'Model Arama',
  areaSearch: 'Bölge Arama',
  brand: 'Marka',
  model: 'Model',
  totalVoyage: 'Sefer',
  totalDistance: 'KM',
  totalTime: 'Süre',
  shuttleTime: 'Saat',
  all: 'Tümü',
  transferDay: 'Transfer Günü',
  targetAddress: 'Hedef Adres',
  target: 'Hedef',
  startAddress: 'Başlangıç Adresi',
  address: 'Adres',
  comment: 'Yorum',
  aciklama: 'Açıklama',
  name: 'Ad',
  fullname: 'Ad & Soyad',
  phoneNumber: 'Telefon Numarası',
  phone: 'Telefon',
  checkFormValidation: 'Lütfen formu kontrol ediniz.',
  transferCreated: 'Transfer isteği oluşturuldu.',
  copy: 'Kopyala',
  requestForm: 'İstek Formu',
  passenger: 'Yolcu',
  addPassenger: 'Yolcu Ekle',
  paginationShowing: 'Toplam {0} kayıttan {1} - {2} arası gösteriliyor.',
  plate: 'Plaka',
  driver: 'Sürücü',
  driverSecond: '2. Sürücü',
  driverPhone: 'Sürücü Tel',
  chooseCar: 'Araç Seç',
  chooseDriver: 'Sürücü Seç',
  chooseDriverSecond: '2. Sürücü Seç',
  carTxt: 'Araç',
  clear: 'Temizle',
  filters: 'Filtrele',
  transferDuration: 'Süre',
  transferDistance: 'GPS KM',
  showStat: 'Grafiği göster',
  hideStat: 'Grafiği gizle',
  exportExcel: 'Excel\'e aktar',
  importExcel: 'Excel\'den içeri aktar',
  clearFilter: 'Filtreyi Temizle',
  refresh: 'Yenile',
  uploadText: 'Yüklemek için dosyayı buraya sürükleyin veya tıklayın.',
  excelExampleFile: 'Örnek aktarım dosyasını indirmek için',
  click: 'tıklayın',
  startLocation: 'Başlangıç Konumu',
  targetLocation: 'Bitiş Konumu',
  start: 'Başlangıç',
  directions: 'Yol Tarifi',
  estimatedTime: 'Tahmini Süre',
  driverCarInfo: 'Sürücü & Araç Bilgisi',
  rejectComment: 'İptal Nedeni',
  rejectUser: 'İptal Eden',
  personalInfo: 'Oluşturan Bilgisi',
  fullName: 'İsim & Soyisim',
  createdDate: 'Oluşturulma Tarihi',
  userComment: 'Oluşturan Yorumu',
  adminComment: 'Yönetici Yorumu',
  userForm: 'Kullanıcı Formu',
  selectRole: 'Rol Seçin',
  role: 'Rol',
  enterStartAdress: 'Başlangıç Adresi',
  enterTargetAdress: 'Bitiş Adresi',
  startAdress: 'Başlangıç Adresi',
  targetAdress: 'Bitiş Adresi',
  login: 'Giriş Yap',
  sendResetLink: 'Sıfırlama Bağlantısı Gönder',
  passwordRecovery: 'Şifremi Unuttum',
  forgotPassword: 'Şifremi unuttum',
  company: 'Firma',
  additionalPassengers: 'Ek Yolcular',
  operationFailed: 'İşlem Başarısız. Lütfen Bilgilerinizi Kontrol Ediniz.',
  recoveryLinkSend: 'Şifre sıfırlama epostası gönderildi.',
  resetPassword: 'Şifremi Sıfırla',
  resetPasswordSuccess: 'Şifreniz başarıyla sıfırlandı',
  myProfile: 'Profilim',
  logOut: 'Çıkış Yap',
  driverWarning: 'Seçilen sürücü aynı gün içerisinde {0} farklı göreve daha atanmıştır.',
  carWarning: 'Seçilen araç aynı gün içerisinde {0} farklı göreve daha atanmıştır.',
  availableCars: 'Müsait Araçlar',
  availableDrivers: 'Müsait Sürücüler',
  plannedCars: 'Planlanan Araçlar',
  enrouteCars: 'Yoldaki Araçlar',
  completions: 'Tamamlananlar',
  vehicles: 'Araçlar',
  shuttlePlanCreate: 'Yeni Servis Planı',
  shuttlePlanEdit: 'Servis Planı Düzenle',
  shuttlePlans: 'Servis Planları',
  shuttlePlanCreated: 'Servis Planı Başarıyla Oluşturuldu',
  shuttleRegisterList: 'Servis Listesi',
  shuttleCancel: 'Servis İsteği İptal Edildi.',
  moveShuttle: 'Servis Kaydına Çevir',
  newShuttleRegisterRequest: 'Yeni Servis İsteği',
  route: 'Güzergah',
  departureAddress: 'Alınacak Adres',
  arrivalAddress: 'Bırakılacak Adres',
  chooseLocation: 'Konum Seçiniz',
  choose: 'Seçiniz',
  enter: 'Giriş',
  exit: 'Çıkış',
  shuttleRegisterDetails: 'Kayıt Detayı',
  unassigned: 'Atanmamış',
  success: 'İşlem Başarılı',
  selected: 'Seçilen',
  daySelected: '{count} gün seçildi',
  dates: 'Tarihler',
  selfDriveRequest: 'Sürücüsüz Araç Talep Et',
  type: 'Tipi',
  description: 'Açıklama',
  transferMoveShuttle: 'Baş Şoförlük tarafından servis talebi olarak değiştirilmiştir. Servis Adı: {0} Saati: {1}',
  specifications: 'Tanımlamalar',
  createSpecification: 'Tanımlama Oluştur',
  editSpecification: 'Tanımlama Düzenle',
  vehicleType: 'Araç Cinsi',
  vehicleTypes: 'Araç Cinsleri',
  createVehicleType: 'Araç Cinsi Oluştur',
  vehicleTypeCreated: 'Araç cinsi oluşturuldu.',
  vehicleTypeInfo: 'Araç Cinsi Bilgileri',
  vehicleTypeName: 'Araç Cinsi Adı',
  selectVehicleType: 'Araç Cinsi Seçiniz',
  notify: {
    approved: '#{0} nolu talebiniz onaylandı',
    rejected: '#{0} nolu talebiniz iptal edildi',
    setDriver: '#{0} nolu talebiniz için araç ve sürücü atandı',
    leadRejected: 'Araç atanan #{0} nolu transfer iptal edildi.',
    driverSet: '#{0} nolu transfer isteği size atandı.',
    driverRejected: '#{0} nolu transfer iptal edildi.',
    adminCreated: 'Yeni transfer isteği oluşturuldu.',
    driverChanged: '#{0} nolu transfer isteğinin sürücüsü değiştirildi.',
    driverPlateChanged: '#{0} nolu transfer isteğinin araç plakası değiştirildi'
  },
  titles: {
    home: 'Anasayfa',
    login: 'Giriş Sayfası',
    transfer: 'Transfer Detayları',
    users: 'Kullanıcı Listesi',
    createUser: 'Kullanıcı Oluştur',
    transferRequest: 'Transfer İsteği',
    board: 'Pano',
    vehicles: 'Araçlar',
    shuttlePlanList: 'Servis Plan Listesi',
    newShuttlePlan: 'Yeni Servis Planı',
    shuttleRegisterList: 'Servis Kayıt Listesi',
    shuttleRegister: 'Servis Kaydı',
  },
  status: [
    'Onay Bekleniyor',
    'Araç atanacak',
    'Kalkış için bekliyor',
    'Yolda',
    'Tamamlandı',
    'İptal edildi',
  ],
  userStatus: {
    true: 'Aktif',
    false: 'Pasif'
  },
  vehicleStatus: {
    true: 'Atandı',
    false: 'Bekliyor'
  },
  itemStatus: {
    true: 'Aktif',
    false: 'Pasif',
  },
  selfDrive: {
    true: 'Sürücüsüz',
    false: 'Normal',
  },
  dateTimePicker: {
    monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
    dayNames: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt']
  },
  filter: {
    id: 'ID',
    name: 'Ad Soyad',
    user_name: 'Ad Soyad',
    departure: 'Kalkış',
    target: 'Varış',
    driver: 'Sürücü',
    secondDriver: '2. Sürücü',
    plate: 'Plaka',
    dateRange: 'Tarih',
    status: 'Durum',
    brand: 'Marka',
    model: 'Model',
    area: 'Bölge',
    type: 'Tipi',
    self_drive: 'Tipi',
    to_province: 'Varış İl',
    to_district: 'Varış İlçe',
    to_neighborhood: 'Varış Mahalle',
    to_address_line: 'Varış Adres',
    demandant_name: 'Talep Eden',
    from_province: 'Kalkış İli',
    from_district: 'Kalkış İlçe',
    from_neighborhood: 'Kalkış Mah.',
    from_address_line: 'Kalkış Adres',
    number_of_seats: 'Koluk Sayısı',
    createdAtRange: 'Oluş. Tarih',
    created_at_range: 'Oluş. Tarih',
    startTimeRange: 'Baş. Tarih',
    endTimeRange: 'Bit. Tarih',
    service_date_range: 'Tarih',
    service_type: 'Talep Türü',
    request_unit: 'Talep Eden Birim',
    requested_unit: 'Talep Edilen Birim',
    vehicle_type: 'Araç Cinsi',
    vehicle_types: {
      name: 'Araç Cinsi Adı',
      is_active: 'Durum',
      created_at_range: 'Oluş. Tarih',
    },
    departments: {
      name: 'Departman Adı',
      is_active: 'Durum',
    },
  },
  smartTable: {
    enter: 'Giriş',
    exit: 'Çıkış',
    active: 'Aktif',
    passive: 'Pasif',
    true: 'Etkin',
    false: 'Devre Dışı',
  },
  roles: {
    1: 'Superman',
    2: 'Yönetici',
    3: 'Baş Şoför',
    4: 'Şoför',
    5: 'Superuser',
  },
}
